import * as React from 'react';
import { Container, Form, FormGroup, Input } from 'reactstrap';

import * as AuthApi from '../../api/auth';

import Localization from '../../config/localization';

import Loader from '../../components/Loader';

import { PASSWORD_MIN_LENGTH } from '../../constants/constants';
import { RESET_PASSWORD_TIMEOUT } from '../../constants/resetPassword';

import Notifications from '../../lib/notifications';
import { ToString } from '../../lib/utils';

import './ResetPassword.scss';
import { Routes } from '../../constants/routes';

class ResetPassword extends React.Component<ResetPassword.IProps, ResetPassword.IState> {
  state = {
    confirmPassword: '',
    password: '',

    id: ToString(this.props.match.params.id),
    token: ToString(this.props.match.params.token),

    loading: false,
    loadingMessage: ''
  };

  componentDidMount() {
    const tokenExist = this._validateTokenAndId();

    if (!tokenExist) {
      return this.props.history.push(Routes.Login);
    }

    return this._doValidateToken();
  }

  render() {
    return (
      <Container fluid className="p-0 d-flex reset-password-container">
        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <div className="reset-password-image w-75 h-80">
          <h1 className="eon-title third-field eon-white wrap-pre-line text-right mr-5 mt-5 pt-5">{Localization.resetPasswordTitle}</h1>
        </div>
        <div className="bg-eon-red text-left w-25 reset-password-form h-80 d-flex">
          <div className="p-5 mt-auto mb-5 w-100 h-100 form-container">
            <h4 className="eon-title eon-white">{Localization.resetPasswordFormLabel}</h4>
            <Form onSubmit={this._doSubmit} className="mt-4">
              <FormGroup>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  className="w-80 eon-input-text-no-label eon-red"
                  onChange={this._setPassword}
                  placeholder={Localization.resetPasswordPasswordPlaceholder}
                  minLength={PASSWORD_MIN_LENGTH}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="w-80 eon-input-text-no-label eon-red"
                  onChange={this._setPassword}
                  placeholder={Localization.resetPasswordConfirmPasswordPlaceholder}
                  minLength={PASSWORD_MIN_LENGTH}
                  pattern={this.state.password}
                  required
                />
              </FormGroup>
              <div className="d-flex mt-3">
                <button className="reset-password-button eon-button bg-eon-white eon-red">
                  <span className="reset-password-button-span">{Localization.resetPasswordChangeButton}</span>
                </button>
                <a className="p-0 h-100 ml-4 my-auto c-pointer eon-white" onClick={this._goToLogin}>
                  {Localization.resetPasswordGoToLogin}
                </a>
              </div>
            </Form>
          </div>
        </div>
      </Container>
    );
  }

  _validateTokenAndId = () => {
    if (!this.state.id || !this.state.token) {
      Notifications.error(Localization.resetPasswordInvalidToken);
      return false;
    }

    return true;
  };

  _doValidateToken = async () => {
    try {
      await AuthApi.ValidateToken({ token: this.state.token, id: this.state.id });

      return undefined;
    } catch (error) {
      Notifications.error(error.message);

      await this.setState({ loading: false });

      return this.props.history.push(Routes.HomePage);
    }
  };

  _doSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      if (this.state.loading || !this._validateTokenAndId()) {
        return undefined;
      } else if (!this.state.password || !this.state.confirmPassword) {
        throw new Error(Localization.resetPasswordInvalidPassword);
      }

      await this.setState({ loading: true });

      await AuthApi.ResetPassword({ password: this.state.password, token: this.state.token, id: this.state.id });

      await this.setState({ loading: false });

      return setTimeout(this.props.history.push, RESET_PASSWORD_TIMEOUT, Routes.Login);
    } catch (error) {
      Notifications.error(error.message);

      return this.setState({ loading: false });
    }
  };

  _goToLogin = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    return this.props.history.push(Routes.Login);
  };

  _setPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    return this.setState(prevState => ({ ...prevState, [element.name]: element.value }));
  };
}

export default ResetPassword;
